// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VIeJ","left":"styles_left__2UVgl"};